export const links = {
	paymentRedirectUrl: 'https://account.meverifyng.com',
	// AUTH ENDPOINTS
	login: 'login',
	loginVerify: 'verify-login',
	forgotPassword: 'forgot-password',
	resetPassword: 'reset-password',
	createAccount: 'create-account',
	verifyRegister: 'verify-registration',
	createToken: 'create-verification-token',
	checkToken: 'check-verification-token',
	// INVITES ENDPOINTS
	listInvites: 'invites/invitations',
	createInvites: 'invites/create-invite',
	deleteInvites: 'invites/delete-invite',
	// ACCOUNT ENDPOINTS
	accountProfile: 'account/profile',
	changePassword: 'account/change-password',
	signOut: 'account/logout',
	updateAccount: 'account/update-profile',
	toggleTFA: 'account/toggle-2-factor',
	// API CALLS ENDPOINTS
	apiCalls: 'api-calls',
	deleteApiCalls: 'api-calls/delete-api-call',
	// API KEYS ENDPOINTS
	apiKeys: 'api-keys',
	revealApiKey: 'api-keys/reveal-key',
	generateKey: 'api-keys/generate-key',
	// COMPANIES ENDPOINTS
	companies: 'companies',
	editCompany: 'companies/edit-company',
	editCompanySettings: 'companies/edit-company-settings',
	// DASHBOARD
	dashboard: 'dashboard',
	// INVOICES
	invoices: 'invoices',
	createInvoice: 'invoices/create-invoice',
	downloadInvoice: 'invoices/download-invoice',
	// PAYMENT ACCOUNTS
	paymentAccounts: 'payment-accounts',
	// PLANS
	plans: 'plans',
	// PRODUCTS
	products: 'products',
	// PROJECTS
	projects: 'projects',
	createProject: 'projects/create-project',
	editProject: 'projects/edit-project',
	changeProjectStatus: 'projects/change-status',
	deleteProject: 'projects/delete-project',
	editProjectSettings: 'projects/edit-project-settings',
	// TEAMS
	teams: 'teams',
	removeMember: 'teams/remove-member',
	changeTeamRole: 'teams/change-role',
	// TRANSACTIONS
	transactions: 'transactions',
	// USER ROLES
	roles: 'roles',
	roleSimple: 'roles/simple',
	createRole: 'roles/create-role',
	editRole: 'roles/edit-role',
	deleteRole: 'roles/delete-role',
	permissions: 'permissions',
	// USERS
	users: 'users',
	changeUserStatus: 'users/change-status',
	deleteUser: 'users/delete-user',
	companiesUser: 'users/companies',
	// WALLETS
	wallets: 'wallets',
	viewWallet: 'wallets/single',
	currencies: 'wallets/currencies',
	createWallet: 'wallets/create-wallet',
	updateThreshold: 'wallets/update-threshold',
	initiateDeposit: 'wallets/deposit',
	verifyDeposit: 'wallets/verify-deposit',
	// OTHERS
	documentationUrl: 'https://documentation.meverifyng.com/',
	// verification
	bvnVerify: 'bvn-verify',
	ninVerify: 'nin-verify',
};
